import React, { useState } from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { LeaveAndUpcomingHistoryListType } from "../../../redux/stcoTools/stcoToolsType";
import {
  LEAVE_HISTORYT_HEADERS,
  WFH_HISTORYT_HEADERS,
} from "../../../constant/tableHeadersConstants/stcoTools/leaveAndWFHTableHeader";
import { EmptyListPage, TableLoader } from "../../commons";
import WFHAndLeavesHistoryTable from "./WFHAndLeavesHistoryTable/WFHAndLeavesHistoryTable";
interface TabsType {
  name: string;
  label: string;
  display: boolean | undefined;
}
let tabs: TabsType[] = [
  {
    name: "Leave History",
    label: "Leave History",
    display: true,
  },
  {
    name: "Work From Home History",
    label: "Work From Home History",
    display: true,
  },
];

type AppProps = {
  tableHeader: TableHeadersType[];
  data: [] | LeaveAndUpcomingHistoryListType[];
  handleRequestReject?: (data: string) => void;
  handleRequestAppoved?: (data: string) => void;
  openDrawer?: () => void;
  setSingleLeaveId?: React.Dispatch<React.SetStateAction<string>>;
  fetching: boolean;
  isApplyWFHApplyPresent: boolean;
};
const WFHandLeavesHistory = ({
  tableHeader,
  data,
  handleRequestAppoved,
  handleRequestReject,
  openDrawer,
  setSingleLeaveId,
  fetching,
  isApplyWFHApplyPresent,
}: AppProps) => {
  if (!isApplyWFHApplyPresent) {
    tabs = tabs.slice(0, 1);
  }
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const leaveHistoryData =
    data?.length > 0
      ? data?.filter((el: LeaveAndUpcomingHistoryListType) => {
          return el?.leave_type !== "WFH";
        })
      : [];

  const wfhHistoryData =
    data?.length > 0
      ? data?.filter((el: LeaveAndUpcomingHistoryListType) => {
          return el?.leave_type == "WFH";
        })
      : [];

  const renderTabs = () => {
    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
                fontSize: "14px",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };
  return (
    <div>
      <div className="p-0">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div className="d-flex">{renderTabs()}</div>
        </div>
        {activeTab === "Leave History" &&
          (fetching ? (
            <TableLoader Rows={10} ColumnPerRow={6} />
          ) : leaveHistoryData?.length ? (
            <WFHAndLeavesHistoryTable
              tableHeader={LEAVE_HISTORYT_HEADERS}
              data={leaveHistoryData}
              openDrawer={openDrawer}
              setSingleLeaveId={setSingleLeaveId}
              fetching={fetching}
            />
          ) : (
            !fetching && (
              <div className="p-5 mt-3">
                <EmptyListPage title="No List Found!" imageWidth="30%" />
              </div>
            )
          ))}
        {activeTab === "Work From Home History" &&
          (fetching ? (
            <TableLoader Rows={10} ColumnPerRow={6} />
          ) : wfhHistoryData?.length ? (
            <WFHAndLeavesHistoryTable
              tableHeader={WFH_HISTORYT_HEADERS}
              data={wfhHistoryData}
              openDrawer={openDrawer}
              setSingleLeaveId={setSingleLeaveId}
              fetching={fetching}
            />
          ) : (
            !fetching && (
              <div className="p-5 mt-3">
                <EmptyListPage title="No List Found!" imageWidth="30%" />
              </div>
            )
          ))}
      </div>
    </div>
  );
};

export default WFHandLeavesHistory;
